import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import PackageIcon from "@redotech/redo-web/icon-old/package.svg";
import { produce } from "immer";
import * as React from "react";
import {
  StepDownstream,
  StepId,
  StepType,
  StepTypeDetailsProps,
} from "../step";
import { containsImg } from "./step-rich-text-util";

export interface SeeOrdersState {
  message: string;
  messageHtml?: string;
  next: StepId | undefined;
  customTitle?: string;
}

export const SEE_ORDERS = (
  Details: React.ComponentType<StepTypeDetailsProps<SeeOrdersState>>,
): StepType<SeeOrdersState, ModelStep.SeeOrders> => ({
  Details: (props: StepTypeDetailsProps<SeeOrdersState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  description(state) {
    return state.message;
  },
  downstream(state) {
    const result: StepDownstream[] = [];
    if (state.next !== undefined) {
      result.push({ id: state.next });
    }
    return result;
  },
  maxDownstream() {
    return 1;
  },
  empty: {
    message: "Please sign in with your email address to see your orders.",
    messageHtml: undefined,
    next: undefined,
  },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {
      if (state.next === stepId) {
        state.next = undefined;
      }
    });
  },
  title: STEP_TYPE_NAMES[ModelStep.SEE_ORDERS],
  valid(state) {
    return (
      state.next !== undefined &&
      !!state.message &&
      !containsImg(state.messageHtml)
    );
  },
  fromModel(model, id) {
    return {
      customTitle: model.customTitle,
      message: model.message,
      messageHtml: model.messageHtml,
      next: id(model.next),
    };
  },
  toModel(state, id) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.SEE_ORDERS,
      message: state.message,
      messageHtml: state.messageHtml,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      next: id(state.next!),
    };
  },
  Icon: PackageIcon,
});
